import React from "react";
import resumeFile from "../documents/TSpellerResume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2013 - 2017",
      title: "Bachelor of Science in Computer Science",
      place: "Howard University",
      desc: "Graduated cum laude",
    },
    {
      yearRange: "Jan 2014 - Aug 2014",
      title: "Google Edge Participant",
      place: "Google HQ, Mountain View, California",
      desc: "One of fifteen students selected from across the country in this pre-professional career and skill development program. Edge reinforced CS fundamentals, beginner C/C++, and Python skills. Received mentorship from Google engineers.",
    }
  ];

  const experienceDetails = [
    {
      yearRange: "Nov 2022 - Jul 2023",
      title: "Software Engineer II/FullStack Developer",
      place: "IT Concepts",
      desc: "Designed and developed a ReactJS redesign of the Aries product which made it significantly faster and easier to maintain. (Moved from being java based to simply React and served by nginx).",
    },
    {
      yearRange: "Apr 2018 - Oct 2022",
      title: "Software Engineer II/FullStack Developer",
      place: "Cvent",
      desc: "Was promoted within first 9 months. Designed and developed many of the latest user-facing features of their registration software (FLEX) using ReactJS and built reusable components & front-end libraries for future use. Participated in architecture, design and implementation of back-end microservices using Java. Did end-to-end testing and wrote automation scripts.",
    },
    {
      yearRange: "Aug 2015 - May 2017",
      title: "Undergraduate Teaching Assistant",
      place: "Howard University",
      desc: "Responsible for providing supplemental material to a class of 30+ students and assists with weekly labs/lectures. Reiterate concepts students learned in class and provide interview prep.",
    },
  ];

  const skills = [
    {
      name: "HTML/CSS",
      percent: 95,
    },
    {
      name: "JavaScript",
      percent: 80,
    },
    {
      name: "React JS",
      percent: 95,
    },
    {
      name: "NodeJS",
      percent: 85,
    },
    {
      name: "Java",
      percent: 80,
    },
    {
      name: "Python",
      percent: 70,
    },
    {
      name: "SQL",
      percent: 80,
    },
    {
      name: "C#",
      percent: 70,
    },
    {
      name: "Docker",
      percent: 75
    }
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
